import React, {ChangeEvent, KeyboardEventHandler, useEffect, useState} from "react";
import {Input} from "../../../ui-components/Input/Input";
import {ValidationErrorText} from "../../../ui-components/ValidationErrorText/ValidationErrorText";
import {ValidationWarningText} from "../../../ui-components/ValidationWarningText/ValidationWarningText";

interface AmountInputProps {
    amount: string;
    maxAmount: string;
    onSetAmount: (amount: string) => void;
    onSetIsAmountValid: (isAmountValid: boolean) => void;
}

export const AmountInput: React.FunctionComponent<AmountInputProps> = (props) => {
    const [errors, setErrors] = useState<string[]>([]);
    const [warnings, setWarnings] = useState<string[]>([]);
    const [isValid, setIsValid] = useState<boolean>(true);
    const maxAmountWarning = 'Please notice that the amount is greater than the maximum amount.';
    const negativeAmountError = 'The amount is below zero.';
    const notANumberError = 'Not a number.';
    const requiredAmountError = 'Amount is a required field.';

    useEffect(() => {
        props.onSetIsAmountValid(isValid);
    }, [isValid])

    const onChange = (event: ChangeEvent) => {
        props.onSetAmount((event.target as HTMLInputElement).value);
        validateAmount();
    }

    const onKeyUp = (event: React.KeyboardEvent<HTMLInputElement>) => {
        validateAmount();
    }

    const validateAmount = () => {
        let warningsTemp: string[] = [];
        let errorsTemp: string[] = [];
        if (getAmountAsNumber(props.amount) < 0) {
            errorsTemp.push(negativeAmountError);
        }
        if (!Number.isFinite(parseFloat(props.amount))) {
            errorsTemp.push(notANumberError);
        }
        if (props.amount === '') {
            errorsTemp.push(requiredAmountError);
        }
        if (getAmountAsNumber(props.amount) > getAmountAsNumber(props.maxAmount)) {
            warningsTemp.push(maxAmountWarning);
        }
        setWarnings(warningsTemp);
        setErrors(errorsTemp);
        setIsValid(errorsTemp.length === 0);
    }

    const getAmountAsNumber = (amount: string) => {
        let amountNumber = parseFloat(amount);
        return amountNumber || 0;
    }

    return <div>
        <Input isValid={isValid} type='number' required={true} value={props.amount} onChange={onChange}
               onKeyUp={onKeyUp} disabled={true}/>
        {errors.map((error: string) => {
            return <ValidationErrorText key={error} text={error}/>
        })}
        {warnings.map((warning: string) => {
            return <ValidationWarningText key={warning} text={warning}/>
        })}
    </div>
}